import React from 'react';
import Paragraph from "@scentregroup/ui/components/paragraph";
import style from '../index.module.scss';
import { getCentreAcknowledgement } from '@scentregroup/shared/helpers/get-centre-acknowledgement';
import { jsx as _jsx } from "react/jsx-runtime";
export const AcknowledgementSection = _ref => {
  let {
    country,
    centreSlug = undefined
  } = _ref;
  return /*#__PURE__*/_jsx(Paragraph, {
    className: style.responsibleBusinessSection,
    "data-id": "acknowledgement-section_index_AcknowledgementSection_Paragraph",
    children: getCentreAcknowledgement(country, centreSlug)
  });
};